import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'permilleFormat',
    standalone: false
})
export class PermilleFormatPipe implements PipeTransform {
  transform(value: number, printPermille = true): string {

    if (value === null || value === undefined) {
      return '-NV-';
    }

    return (value * 1000).toFixed(3) + (printPermille ? '‰' : '');
  }
}
